import React from 'react';
import BaseComponent from '../_base/baseComponent';
import { cssClasses } from '@douyinfe/semi-foundation/lib/es/scrollList/constants';
import classnames from 'classnames';
import propTypes from 'prop-types';
import ScrollItem from './scrollItem';
import Foundation from '@douyinfe/semi-foundation/lib/es/scrollList/foundation';
import '@douyinfe/semi-foundation/lib/es/scrollList/scrollList.css'; // eslint-disable-next-line @typescript-eslint/ban-types

class ScrollList extends BaseComponent {
  constructor(props) {
    super(props);
    this.foundation = new Foundation(this.adapter);
  }

  render() {
    const {
      children,
      header,
      footer,
      prefixCls,
      bodyHeight,
      className,
      style
    } = this.props;
    const clsWrapper = classnames(className, {
      [prefixCls || cssClasses.PREFIX]: true
    });
    const clsHeader = classnames({
      ["".concat(prefixCls || cssClasses.PREFIX, "-header")]: true
    });
    return /*#__PURE__*/React.createElement("div", {
      className: clsWrapper,
      style: style
    }, header ? /*#__PURE__*/React.createElement("div", {
      className: clsHeader
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsHeader, "-title"),
      "x-semi-prop": this.props['x-semi-header-alias'] || "header"
    }, header), /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsWrapper, "-line")
    })) : null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsWrapper, "-body"),
      style: {
        height: bodyHeight ? bodyHeight : ''
      },
      "x-semi-prop": "children"
    }, children), footer ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(clsWrapper, "-footer"),
      "x-semi-prop": this.props['x-semi-footer-alias'] || "footer"
    }, footer) : null);
  }

}

ScrollList.Item = ScrollItem;
ScrollList.propTypes = {
  className: propTypes.string,
  header: propTypes.node,
  footer: propTypes.node,
  children: propTypes.node,
  bodyHeight: propTypes.oneOfType([propTypes.number, propTypes.string])
};
export default ScrollList;